import React, {useEffect} from "react";
import {Field, useField} from "react-final-form";
import {
    checkEmailAvailable,
    composeValidators,
    regEmailValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import TextField from "../../../HTMLEntities/Textfield";
import {UserEmail} from "../../../../containers/RegistrationLoginPage/types";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
import {pageTrackingData, trackClickEvent} from "../../../../utils/utils";
import {ABROAD_SIGN_UP_PROP_MAP} from "../../../../containers/RegistrationLoginPage/utils";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {PageTrackingData} from "../../../CTA/types";

interface EmailFieldInterface {
    configuration: UserEmail;
    autoComplete?: "off" | "username";
    validation?: ((msg: string) => string | undefined | Promise<string | undefined>)[];
}

const EmailField: React.FC<EmailFieldInterface> = ({
    configuration,
    autoComplete = "off",
    validation = [regEmailValidate, checkEmailAvailable],
}: EmailFieldInterface) => {
    const {fieldName, selectedValue, editable} = configuration;

    const {meta} = useField(fieldName);
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const currentPage = useSelector((state: RootStore) => state.layout.currentPageName);

    useEffect(() => {
        if (meta.touched) {
            const gaTrackingData = (pageTrackingData(
                isMobile,
                ABROAD_SIGN_UP_PROP_MAP,
                currentPage,
                "emailFieldTracking",
            ) as PageTrackingData)?.emailFieldTracking;

            // GA TRACKING
            gaTrackingData &&
                trackClickEvent(gaTrackingData.eventCategory, gaTrackingData?.eventAction ?? "");
        }
    }, [meta.touched, isMobile, currentPage]);

    return (
        <Field<string>
            name={fieldName}
            {...(editable
                ? {
                      validate: composeValidators(...validation),
                  }
                : {})}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <TextField
                        placeholder="Email ID"
                        type="email"
                        maxLength={125}
                        autoComplete={autoComplete}
                        initialValue={props?.input?.value ?? ""}
                        isFocused={props?.meta?.active ?? false}
                        isFilled={props?.input?.value?.length > 0}
                        error={errorHandler(props?.meta)}
                        isTouched={props?.meta?.touched}
                        isDisabled={!editable}
                        inputRFF={props?.input}
                    />
                );
            }}
        </Field>
    );
};
export default EmailField;
